import moment from 'moment'
import { validateGreaterThanOrEqualToZero } from 'utils/validate'

export default [{
  name: 'instanceId',
  validation: [],
}, {
  name: 'ticketType',
  validation: [
    v => !v && 'The voucher name is required.',
    v => v && v.length > 100 && 'The name must be less than 100 characters.',
  ],
}, {
  name: 'ticketCount',
  validation: [
    v => v == null && 'Ticket count is required.',
    v => v != null && (
      v.length === 0 || isNaN(Number(v)) || Number(v) < 0
    ) && 'Ticket count must be a positive number.',
    v => Math.floor(Number(v)) !== Number(v) && 'Ticket count must be a whole number.',
  ],
}, {
  name: 'voucherValidFrom',
  validation: [
    v => v == null && 'Valid from is required.',
  ],
}, {
  name: 'voucherValidTo',
  validation: [
    v => v == null && 'Valid to is required.',
    (v, model) => moment(v).isBefore(model.voucherValidFrom) && 'Valid to must be after valid from.'
  ],
}, {
  name: 'onsaleTime',
  validation: [
    v => v == null && 'Onsale time is required.',
  ],
}, {
  name: 'offsaleTime',
  validation: [
    v => v == null && 'Offsale time is required.',
    (v, model) => moment(v).isBefore(model.onsaleTime) && 'Offsale time must be after onsale time.'
  ],
}, {
  name: 'discountPrice',
  validation: [
    v => v == null && 'Discount price is required.',
    v => !validateGreaterThanOrEqualToZero(v) && 'Discount price must be a positive number or zero.'
  ],
}, {
  name: 'initialPrice',
  validation: [
    v => v == null && 'Initial price is required.',
    v => !validateGreaterThanOrEqualToZero(v) && 'Initial price must be a positive number or zero.'
  ],
}, {
  name: 'commission',
  validation: [
    v => v == null && 'Commission is required.',
    v => !validateGreaterThanOrEqualToZero(v) && 'Commission must be a positive number or zero.',
    v => Number(v) >= 100 && 'Commission must be less than 100%.',
  ],
}
]



/** WEBPACK FOOTER **
 ** ./src/components/setupform-vouchers-form/fields.js
 **/